/**
 * ANDROID BILLING BRIDGE — the only place the app asks "am I inside the Google Play app?".
 *
 * On Android, Premium is bought through Google Play Billing. Stripe checkout and the Stripe
 * customer portal are never used there. Prices come from Google, never from a hard-coded string.
 */

import { Capacitor, registerPlugin } from '@capacitor/core';

const PlayBilling = registerPlugin('PlayBilling');

export const isAndroidApp = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

/** Google's own localized price strings, per base plan. Empty when not on Android. */
export const fetchPlayBasePlans = async (subscriptionId) => {
  if (!isAndroidApp() || !subscriptionId) return [];
  const { basePlans } = await PlayBilling.getProducts({ subscriptionId });
  return basePlans || [];
};

/**
 * Buy one base plan, then hand the token to the backend, which asks Google what it really is.
 * Nothing is granted client-side.
 */
export const purchasePlayPlan = async ({ subscriptionId, basePlanId, accountId, verify }) => {
  const result = await PlayBilling.purchase({ subscriptionId, basePlanId, accountId });
  if (result?.cancelled) return { cancelled: true };
  const tokens = result?.purchaseTokens || [];
  if (!tokens.length) return { cancelled: true };
  return verify(tokens[0]);
};

/** Re-link any purchase this device holds, so a purchase can never be orphaned. */
export const restorePlayPurchases = async (verify) => {
  const { purchaseTokens } = await PlayBilling.restore();
  const tokens = purchaseTokens || [];
  if (!tokens.length) return { restored: false };
  return verify(tokens[0]);
};

export const openPlayManage = (url) => PlayBilling.openManage({ url });
